var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationPlaceholderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_8954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 0.537598C6.09597 0.537598 2.50391 4.12966 2.50391 8.53376C2.50391 10.2806 3.05745 11.9413 4.10319 13.3314L10.008 21.2866C10.094 21.4095 10.3278 21.5326 10.5001 21.5326C10.6846 21.5326 10.9061 21.3973 10.9922 21.2865C11.0167 21.2496 16.9585 13.2453 17.0077 13.1714C17.02 13.1714 17.02 13.1714 17.02 13.1592C17.9796 11.806 18.4962 10.2067 18.4962 8.53376C18.4962 4.12971 14.9042 0.537598 10.5001 0.537598ZM10.5001 12.8394C8.12592 12.8394 6.19445 10.908 6.19445 8.53376C6.19445 6.15953 8.12592 4.22814 10.5001 4.22814C12.8742 4.22814 14.8057 6.15953 14.8057 8.53376C14.8057 10.908 12.8742 12.8394 10.5001 12.8394Z",
    fill: "url(#paint0_linear_39_8954)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.532715V4.22326C12.8741 4.22326 14.8056 6.15464 14.8056 8.52887C14.8056 10.9031 12.8741 12.8345 10.5 12.8345V21.5277C10.6846 21.5277 10.9061 21.3924 10.9921 21.2817C11.0166 21.2447 16.9584 13.2404 17.0077 13.1666C17.02 13.1666 17.02 13.1666 17.02 13.1543C17.9795 11.8011 18.4961 10.2019 18.4961 8.52887C18.4962 4.12478 14.9041 0.532715 10.5 0.532715Z",
    fill: "url(#paint1_linear_39_8954)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_8954",
    x1: 2.50391,
    y1: -0.751568,
    x2: 21.149,
    y2: 1.44887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF02A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_8954",
    x1: 10.5,
    y1: -0.756451,
    x2: 19.9196,
    y2: -0.200618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF02A7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_8954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0 0.532715)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPlaceholderIcon);
export default __webpack_public_path__ + "static/media/LocationPlaceholderIcon.44c5c0bda720a41a9cb816614c34defa.svg";
export { ForwardRef as ReactComponent };